import React, { Fragment } from 'react';
import FieldDisplay from 'field/display/FieldDisplay';
import ResourceDisplay from 'field/display/ResourceDisplay';

export default function RelatedObjectDisplay({field}) {
  return (
    <Fragment>
      {
        field.values.map((value, i) => {
          if (!value.fields) {
            return null;
          }

          const { target, inverse, number, association, note } = value.fields;
          const linkField = target || inverse;

          if (!linkField) {
            return null;
          }

          const isShaded = i % 2 === 0;
          const className = 'resource ' + (isShaded ? 'shaded' : '');

          return (
            <div key={i} className={className} style={{marginBottom: '1rem', border: '1px solid gainsboro'}}>
              <ResourceDisplay field={linkField} shaded={isShaded} />
              <FieldDisplay field={number} />
              <FieldDisplay field={association} />
              <FieldDisplay field={note} />
            </div>
          );
        })
      }
    </Fragment>
  );
}